import script from "./CountryNum.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryNum.vue?vue&type=script&setup=true&lang=ts"

import "./CountryNum.vue?vue&type=style&index=0&id=ec689b5e&scoped=true&lang=css"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec689b5e"]])

export default __exports__